<div class="student-management-container" *ngIf="!isUserInfoSelected">
  <div class="left">
    <div class="title">Categories</div>
    <div class="list">
      <div
        class="category"
        (click)="onSelectCategory(category)"
        [ngClass]="{ active: selectedCategory == category }"
        *ngFor="let category of categories"
      >
        {{ category }}
      </div>
    </div>
  </div>
  <div class="right">
    <div class="title">Student List</div>
    <div class="filter">
      <div
        class="category"
        (click)="onChangeEnrollFilter('all')"
        [ngClass]="{ active: enrollFilter === 'all' }"
      >
        All Courses
      </div>
      <div
        class="category"
        (click)="onChangeEnrollFilter('pending')"
        [ngClass]="{ active: enrollFilter === 'pending' }"
      >
        Pending Approvals
      </div>
      <div
        class="category"
        (click)="onChangeEnrollFilter('approved')"
        [ngClass]="{ active: enrollFilter === 'approved' }"
      >
        Approved Courses
      </div>
    </div>
    <div class="student-list">
      <table class="table">
        <tr class="table-header">
          <th [style]="{ width: '10%' }"></th>
          <th [style]="{ width: '25%' }">Student Name</th>
          <th [style]="{ width: '35%' }">Course Attending</th>
          <th [style]="{ width: '30%' }">Date of Enrolement</th>
        </tr>
        <tr class="table-body" *ngFor="let user of usersDetails; let i = index">
          <td [style]="{ width: '10%' }" class="user-icon">
            <div class="icon">
              <i class="fa-solid fa-user"></i>
            </div>
          </td>
          <td [style]="{ width: '25%' }">
            {{ user.firstName }} {{ user.lastName }}
          </td>
          <td [style]="{ width: '35%' }" *ngIf="user.courses.length">
            <div *ngFor="let course of user.courses">
              {{ course.title }}
            </div>
          </td>
          <td
            [style]="{ width: '35%' }"
            *ngIf="
              user.courses.length == 0
            "
          >
            No Courses Enrolled
          </td>
          <td [style]="{ width: '30%' }" *ngIf="user.courses.length">
            <div *ngFor="let course of user.courses" class="last-column">
              <div class="date">
                {{ course.enrollmentDate | date : "dd/MM/yyyy" }}
              </div>
              <div class="menu">
                <div class="menu-icon">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div class="menu-items">
                  <div class="menu-item" (click)="onClickUserInfo(user)">
                    User Info
                  </div>
                  <div
                    class="menu-item"
                    *ngIf="
                      !isCourseRestricted(course._id, user.restrictedCourses)
                    "
                    (click)="restrictOrEnable(user, course, 'restrict')"
                  >
                    Restrict access
                  </div>
                  <div
                    class="menu-item"
                    *ngIf="
                      isCourseRestricted(course._id, user.restrictedCourses)
                    "
                    (click)="restrictOrEnable(user, course, 'enable')"
                  >
                    Enable access
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td
            [style]="{ width: '30%' }"
            *ngIf="
              user.courses.length == 0
            "
          >
            -
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
<div class="user-info" *ngIf="isUserInfoSelected">
  <app-user-info
    [user]="selectedUser"
    (onClose)="onCloseUserInfo($event)"
  ></app-user-info>
</div>
